import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useResponsive } from '@sg/garnish';

import {
  AccountScreenContainer,
  AccountScreenSection,
  AccountScreenTitle,
} from '../AccountScreenContainer';
import {
  SkeletonLoadingContentLG,
  SkeletonLoadingContentSM,
  SkeletonLoadingHeaderXS,
} from './AccountSkeletonLoading';

export const AccountPaymentGiftCardLoading = () => {
  const { formatMessage } = useIntl();
  const { currentBreakpoint } = useResponsive();

  // ─────────────────────────────────────────────────────────────────────

  return (
    <AccountScreenContainer screen="payment-and-gift-cards">
      <AccountScreenTitle
        visibility="COMPACT"
        title={formatMessage(messages.accountPaymentsTitle)}
      />

      <AccountScreenSection>
        {/* Payment Methods */}
        <SkeletonLoadingHeaderXS />
        <SkeletonLoadingContentSM />
        <SkeletonLoadingContentSM />

        {currentBreakpoint.isXS ? (
          <>
            {/* Credit and Promo Code Links */}
            <SkeletonLoadingHeaderXS />
            <SkeletonLoadingContentSM />
            <SkeletonLoadingContentSM />
          </>
        ) : (
          <>
            {/* Credit and Promo Code Form */}
            <SkeletonLoadingHeaderXS />
            <SkeletonLoadingContentLG />
            <SkeletonLoadingContentSM />
            <SkeletonLoadingContentLG />
          </>
        )}
      </AccountScreenSection>
    </AccountScreenContainer>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  accountPaymentsTitle: {
    defaultMessage: 'Payments',
    description: 'Account | Payments | Title',
  },
});
